<template>
  <div class="main">
    <div class="body">
      <router-view/>
    </div>
    <div class="navs">
      <router-link to="/">
        <div class="nav">
          <img :src="$route.meta.id===0?require('@/imgs/home_select.png'):require('@/imgs/home_default.png')">
          <p :style="{color: $route.meta.id===0?'#FF5B39':'#999999'}">首页</p>
        </div>
      </router-link>
      <router-link to="/publish">
        <div class="nav">
          <div class="publish" :style="{background: $route.meta.id===1?'#FF5B39':'#999999'}">
            <img src="@/imgs/release.png">
          </div>
          <p :style="{color: $route.meta.id===1?'#FF5B39':'#999999'}">发布</p>
        </div>
      </router-link>
      <router-link to="/me">
        <div class="nav">
          <img :src="$route.meta.id===2?require('@/imgs/my_select.png'):require('@/imgs/my_default.png')">
          <p :style="{color: $route.meta.id===2?'#FF5B39':'#999999'}">我的</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import {commonConfig} from "@/api/api";

export default {
  name: 'Index',
  methods: {
    async share() {
      let title = '已筛选6位求购用户'
      let desc = '点击此处查看了解发布信息'
      let link = 'https://ptw.qcwpu.com'
      let imgUrl = 'https://qcwpu.oss-cn-beijing.aliyuncs.com/kz/qcwc_share_image.jpg'
      commonConfig({
        url: location.href
      }).then(res => {
        console.log(res)
        let config = res.data
        wx.config({
          debug: false,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: [
            "updateAppMessageShareData",
            "onMenuShareTimeline"
            // "onMenuShareTimeline"
          ] // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          setTimeout(function () {
            wx.updateAppMessageShareData({
              title: title, // 分享标题
              desc: desc, // 分享描述
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: imgUrl, // 分享图标
              success: function () {
                // 用户点击了分享后执行的回调函数
                console.log('success')
              },
              complete: function () {
              }
            });
            wx.onMenuShareTimeline({
              title: title, // 分享标题
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: imgUrl, // 分享图标
              success: function () {
                // 用户点击了分享后执行的回调函数
                console.log('success')
              },
              complete: function () {
              }
            });
          }, 200)
        })
        wx.error(function (res) {
          console.log(res)
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        });
      })
    },
  },
  async mounted() {
    console.log(this.$route.meta.id)
    await this.share()
  }
}
</script>

<style lang="scss" scoped>
.main {
  .body {
    padding-bottom: 114px;
  }

  .navs {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 108px;
    z-index: 10;
    background: #ffffff;
    display: flex;

    a {
      flex: 1;
      text-decoration: none;

      .nav {
        padding: 16px 0;
        display: flex;
        flex-direction: column;

        img {
          height: 36px;
          margin: 0 auto;
        }

        p {
          margin-top: 11px;
          text-align: center;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
        }

        .publish {
          margin: -24px auto 0 auto;
          width: 60px;
          height: 60px;
          background: rgba(255, 92, 57, 1);
          border-radius: 50%;
          display: flex;

          img {
            margin: auto;
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }
}
</style>
